export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/accountability/index/resources/computed.js